// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"buttons_primaryButton__SuvPF","orangeButton":"buttons_orangeButton__2wOYW","ghostButton":"buttons_ghostButton__3b0iU","textButton":"buttons_textButton__1PFRX"};